import { EPopupSubType, ESpecialOfferInternalViewModel } from 'constants/enums';
import { OfferDesignTypes, OfferTypeCardConfig } from 'views/OfferDesign/OfferDesign.types';

import { FilterOption } from 'components/FilterComponents/FilterPopover/types';

import bonusImg from './pages/SelectOfferType/assets/bonus.png';
import bundleImg from './pages/SelectOfferType/assets/bundle.png';
import progressImg from './pages/SelectOfferType/assets/progress.png';
import promotionImg from './pages/SelectOfferType/assets/promotion.png';
import rewardImg from './pages/SelectOfferType/assets/reward.png';
import rollingImg from './pages/SelectOfferType/assets/rolling.png';
import triggeredImg from './pages/SelectOfferType/assets/triggered.png';

export const OFFER_TYPE_FILTER_OPTIONS: FilterOption[] = [
  { label: 'Special Offer', value: OfferDesignTypes.SpecialOffer },
  { label: 'Bundle', value: OfferDesignTypes.Bundle },
  { label: 'Pop Up', value: OfferDesignTypes.PopUp },
  { label: 'Rolling Offer', value: OfferDesignTypes.RollingOffer },
  { label: 'Progress Bar', value: OfferDesignTypes.ProgressBar }
];

export const BUTTON_TEXT = 'Create New Offer Design';

export const FILTER_PARAM_EXTERNAL_ID = 'externalId';
export const FILTER_PARAM_NAME = 'name';
export const FILTER_PARAM_TYPE = 'type';
export const FILTER_TYPE_SEPARATOR = ',';

export const OFFER_TYPE_CARDS: OfferTypeCardConfig[] = [
  {
    key: 'promotions',
    title: 'Promotions',
    description: 'Scheduled promotions featuring one or more products.',
    image: promotionImg,
    offerDesignType: OfferDesignTypes.SpecialOffer
  },
  {
    key: 'bundle',
    title: 'Bundle',
    description: 'Bundles of products sold at a discount or with bonus items.',
    image: bundleImg,
    offerDesignType: OfferDesignTypes.Bundle
  },
  {
    key: 'daily-bonus',
    title: 'Daily Bonus',
    description: 'Recurring rewards that encourage players to return.',
    image: bonusImg,
    offerDesignType: OfferDesignTypes.PopUp,
    subType: EPopupSubType.DAILY_BONUS
  },
  {
    key: 'rolling-offer',
    title: 'Rolling Offer',
    description: 'Unlock the next deal automatically after each purchase.',
    image: rollingImg,
    offerDesignType: OfferDesignTypes.RollingOffer
  },
  {
    key: 'triggered-popup',
    title: 'Triggered Popup',
    description:
      'Contextual offers that appear based on player behavior or events.',
    image: triggeredImg,
    offerDesignType: OfferDesignTypes.PopUp,
    subType: EPopupSubType.POST_PURCHASE
  },
  {
    key: 'progress-bar',
    title: 'Progress Bar',
    description: 'Visual trackers that reward players for completed actions.',
    image: progressImg,
    offerDesignType: OfferDesignTypes.ProgressBar
  },
  {
    key: 'reward-calendar',
    title: 'Reward Calendar',
    description: 'Time-based rewards that unlock daily or periodic rewards.',
    image: rewardImg,
    offerDesignType: OfferDesignTypes.SpecialOffer,
    disabled: true
  }
];

export const OFFER_TYPE_LABELS: Record<OfferDesignTypes, string> = {
  [OfferDesignTypes.Bundle]: 'Bundle',
  [OfferDesignTypes.SpecialOffer]: 'Promotion',
  [OfferDesignTypes.PopUp]: 'Popup',
  [OfferDesignTypes.RollingOffer]: 'Rolling Offer',
  [OfferDesignTypes.ProgressBar]: 'Progress Bar'
};

export const DEFAULT_BACKGROUND_COLOR = '#FFFFFF';

export const PREVIEW_CONTAINER_WIDTH = 375;

export const MOCK_PRICES = { priceDisplay: '$ 0.00', priceInUsdCents: 2 };

export const DEFAULT_BORDER_COLOR = { colorOne: '#ffffff' };
export const DEFAULT_BORDER_WIDTH = 0;

export const PROMOTION_DEFAULTS = {
  fontSize: 20,
  subFontSize: 16,
  fontWeight: 'normal',
  fontColor: { colorOne: '#ffffff' },
  collectText: 'Collect',
  templateType: 'Single'
} as const;

export const SUBTITLE_SUPPORTED_TEMPLATES: ESpecialOfferInternalViewModel[] = [
  ESpecialOfferInternalViewModel.JACKPOT_SLOTS,
  ESpecialOfferInternalViewModel.BIG_FISH_CASINO
];

export const PROGRESS_BAR_DEFAULTS = {
  backgroundOpacity: 80,
  frameRadius: 12,
  barRadius: 12,
  borderWidth: 3,
  barFillColor: { colorOne: '#FFD450', colorTwo: '#EDB923', gradientDirection: 'to bottom' },
  backgroundColor: { colorOne: '#DABA98', colorTwo: '#FDFCF9', gradientDirection: 'to right' },
  borderColor: { colorOne: '#DBBD9C', colorTwo: '#DBBD9C', gradientDirection: 'to right' },
  accumulatedItemBackgroundColor: { colorOne: '#F28CFE', colorTwo: '#9539FB', gradientDirection: 'to bottom' },
  textColor: '#FFFFFF'
} as const;

export const PROGRESS_BAR_PREVIEW_DEFAULTS = {
  collectedPoints: 100,
  activeMissionIndex: 0,
  missionsLength: 1
} as const;

export const MOCK_PROGRESS_BAR_PRODUCTS = {
  barSize: 200,
  products: [
    {
      quantity: 100000,
      quantityDisplay: '100k',
      images: { product: '' }
    }
  ]
};
